export interface PeriodoPlanilla {
  idPeriodo: number;
  anio: number;
  mes: number;
  tipoPeriodo: string; // MENSUAL, SEMANAL, QUINCENAL
  fechaInicio: string;
  fechaFin: string;
  estado: string; // ABIERTO, CALCULADO, CERRADO
  fechaCalculo: string | null;
  fechaCierre: string | null;
  idUsuarioCalculo: number | null;
  idUsuarioCierre: number | null;
  valorUIT: number;
  valorRMV: number;
}

export const ESTADOS_PERIODO = [
  { value: 'ABIERTO', label: 'Abierto', color: 'success' as const },
  { value: 'CALCULADO', label: 'Calculado', color: 'warning' as const },
  { value: 'CERRADO', label: 'Cerrado', color: 'default' as const },
];

export const TIPOS_PERIODO = [
  { value: 'MENSUAL', label: 'Mensual' },
  { value: 'SEMANAL', label: 'Semanal' },
  { value: 'QUINCENAL', label: 'Quincenal' },
];

export const MESES = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' },
];

const currentYear = new Date().getFullYear();

export const initialPeriodo: PeriodoPlanilla = {
  idPeriodo: 0,
  anio: currentYear,
  mes: new Date().getMonth() + 1,
  tipoPeriodo: 'MENSUAL',
  fechaInicio: '',
  fechaFin: '',
  estado: 'ABIERTO',
  fechaCalculo: null,
  fechaCierre: null,
  idUsuarioCalculo: null,
  idUsuarioCierre: null,
  valorUIT: 5350,
  valorRMV: 1025,
};

export interface PeriodoFormErrors {
  anio?: string;
  mes?: string;
  fechaInicio?: string;
  fechaFin?: string;
  valorUIT?: string;
  valorRMV?: string;
}
